/**
 * Plateforme multi événement e.labriquerie.net, (c) Mikaël FOURNY.
 * src/i18n/fr.bilanSoir.ts
 *
 * Messages de la carte « Bilan du soir » (back-office, écran Bilans
 * exposants) : envoi automatique, le jour de l'événement, des chiffres de la
 * journée à chaque structure exposante. 2026-10-08, demande de Mika.
 * Fusionné dans fr.ts.
 *
 * Mikael - chef de projet - 2026-10-08
 */
export const messagesBilanSoirFr: Record<string, string> = {
  'bilanSoir.titre': 'Bilan du soir, envoi automatique',
  'bilanSoir.intro':
    'Le jour de l’événement, à l’heure choisie, chaque structure exposante reçoit un courriel de remerciement avec ses chiffres de la journée (personnes rencontrées sur le stand, CV reçus, entretiens) et un lien vers « Mon stand », où se trouvent ses contacts et leur export. Copie à ses recruteurs. Une structure sans activité ne reçoit rien. Le texte se modifie dans « Modèles d’e-mail ».',
  'bilanSoir.chargement': 'Chargement du bilan du soir…',
  'bilanSoir.erreur': 'L’état du bilan du soir n’a pas pu être chargé.',
  'bilanSoir.interrupteur': 'Envoyer automatiquement le bilan du soir',
  'bilanSoir.allume': 'Bilan du soir allumé.',
  'bilanSoir.eteint': 'Bilan du soir éteint.',
  'bilanSoir.etatEteint': 'Éteint : aucun bilan ne partira.',
  'bilanSoir.heure': 'Heure d’envoi',
  'bilanSoir.enregistrerHeure': 'Enregistrer l’heure',
  'bilanSoir.heureEnregistree': 'Heure d’envoi enregistrée.',
  'bilanSoir.phase.avant': 'Les bilans partiront le {jour} à partir de {heure}.',
  'bilanSoir.phase.ouverte': 'Envoi ouvert ce soir : {envoyes, plural, =0 {aucun bilan envoyé pour l’instant} one {# bilan envoyé} other {# bilans envoyés}}{echecs, plural, =0 {} one {, # échec (nouvel essai au passage suivant)} other {, # échecs (nouvel essai au passage suivant)}}.',
  'bilanSoir.phase.apres': 'Journée terminée : {envoyes, plural, =0 {aucun bilan envoyé} one {# bilan envoyé} other {# bilans envoyés}}.',
  'bilanSoir.phase.sans_date': 'Date de l’événement inconnue : aucun bilan ne partira tant qu’elle n’est pas réglée.',
  'bilanSoir.dernier': 'Dernier passage utile : {date}, {envoyes, plural, =0 {aucun envoi} one {# envoi} other {# envois}}.',
  'bilanSoir.resume.copies': 'Un récapitulatif de chaque passage part {n, plural, one {à # adresse} other {aux # adresses}} en copie des envois d’accès.',
  'bilanSoir.resume.super_admins': 'Aucune adresse en copie réglée : le récapitulatif part {n, plural, one {au super administrateur} other {aux # super administrateurs}}.',
  'bilanSoir.resume.aucun': 'Aucun destinataire pour le récapitulatif : réglez les adresses en copie dans « Codes d’accès ».',
  'bilanSoir.structure': 'Structure',
  'bilanSoir.choisir': 'Choisissez une structure',
  'bilanSoir.apercu': 'Voir le bilan réel',
  'bilanSoir.essai': 'M’envoyer un essai',
  'bilanSoir.essaiOk': 'Essai envoyé à votre adresse.',
  'bilanSoir.essaiKo': 'L’essai n’a pas pu partir.',
  'bilanSoir.apercuTitre': 'Aperçu du courriel',
  'bilanSoir.apercuChiffres': 'Chiffres du {jour} : {rencontres} rencontre(s), {cv} CV, {entretiens} entretien(s){recruteurs, plural, =0 {} one {, copie à # recruteur} other {, copie à # recruteurs}}.',
  'bilanSoir.apercuVide': 'Aucune activité ce jour pour cette structure : elle ne recevra rien.',
  'bilanSoir.apercuSujet': 'Sujet : {sujet}',
  'bilanSoir.apercuCadre': 'Aperçu du courriel du bilan du soir',
  'bilanSoir.aucuneStructure': 'Aucune structure exposante active pour l’instant.',
};
